module.exports = __webpack_public_path__ + "static/media/hero.c89067fe.jpg";